<template>
    <div>
        <b-container>
            <b-row>
                <b-col cols="12">
                    <div>
                        <!-- ID, Display ID, ordinal to be auto-generated -->
                        <b-form-group
                                :state="errorState('type')"
                                invalid-feedback="Required"
                                label="Type:"
                                label-for="ca-type">
                            <b-select
                                    id="ca-type"
                                    v-model="newCustomActivity.type"
                                    :state="errorState('type')"
                                    :options="customActivityTypes" />
                        </b-form-group>
                        <b-form-group
                                :state="errorState('title')"
                                invalid-feedback="Required"
                                label="Title:"
                                label-for="ca-title">
                            <b-input
                                    id="ca-title"
                                    v-model="newCustomActivity.title"
                                    :state="errorState('title')" />
                        </b-form-group>
                        <b-form-group
                                :state="errorState('description')"
                                invalid-feedback="Required"
                                label="Description:"
                                label-for="ca-description">
                            <b-input
                                    id="ca-description"
                                    v-model="newCustomActivity.description"
                                    :state="errorState('description')" />
                        </b-form-group>
<!--                        <b-form-group-->
<!--                                :state="errorState('recommendedTime')"-->
<!--                                invalid-feedback="Required"-->
<!--                                label="Recommended Time:"-->
<!--                                label-for="ca-recommended-time">-->
<!--                            <b-input-->
<!--                                    id="ca-recommended-time"-->
<!--                                    v-model="newCustomActivity.recommendedTime"-->
<!--                                    :state="errorState('recommendedTime')" />-->
<!--                        </b-form-group>-->
                        <b-form-group
                                v-if="hasAssignment"
                                :state="errorState('scheduled')"
                                invalid-feedback="Required (date must be in the future)"
                                label="Scheduled Date:"
                                label-for="ca-scheduled">
                            <CITFDatePicker
                                    id="ca-scheduled"
                                    v-model="newCustomActivity.scheduled"
                                    :state="errorState('scheduled')"
                                    type="month"
                                    format="MMM YYYY" />
                        </b-form-group>
                        <b-button-group
                                class="float-right">
                            <b-button
                                    variant="warning"
                                    @click="resetCustomActivity">Clear Form</b-button>
                            <b-button
                                    variant="danger"
                                    @click="$emit('done')">Cancel</b-button>
                            <b-button
                                    variant="primary"
                                    :disabled="disableSave"
                                    @click="save">Save</b-button>
                        </b-button-group>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import { Prop, Component, Vue} from 'vue-property-decorator';
    import {sprintf} from 'sprintf-js';
    import _ from 'underscore';
    import {User, Trainee, NULL_USER} from "@/model/user";
    import store from '@/store/store';
    import userDao from '@/dao/user_dao';
    import {CustomActivityType, NEW_CUSTOM_ACTIVITY} from "@/model/activity";
    import CITFDatePicker from '@/components/shared/CITFDatePicker.vue';
    import {endOfMonth, set} from "date-fns";
    import {errorModalOptions, errorToastOptions} from "../../../../util/formatters";

    @Component({
        components: {
            CITFDatePicker
        },
        asyncComputed: {},
        methods: {}
    })

    export default class CreateCustomActivity extends Vue {
        //Optional trainee prop for assignment
        @Prop({type: [Trainee, User], default: NULL_USER}) trainee;
        newCustomActivity = NEW_CUSTOM_ACTIVITY;

        async mounted() {
            try {
                await store.dispatch('userSession/loadProfile');
            }
            catch (error) {
                this.$bvToast.toast(error.message, errorToastOptions);
            }
            this.resetCustomActivity();
        }

        get hasAssignment() {
            return !_.isEqual(this.trainee, NULL_USER);
        }

        get currentUser() {
            return store.getters['userSession/getUser'];
        }

        async getTraineeId() {
            try {
                const traineeId = await userDao.getTraineeId(this.trainee.id);
                return traineeId;
            }
            catch (error) {
                this.$bvToast.toast(error.message, errorToastOptions);
                return 0;  //This should never happen
            }
        }

        async resetCustomActivity() {
            this.newCustomActivity = NEW_CUSTOM_ACTIVITY.clone();
            //Set to current generation
            const currentGeneration = store.getters['activities/currentActivityGeneration'];
            this.newCustomActivity.generation = currentGeneration;
            //Creator is current user
            this.newCustomActivity.creator = this.currentUser.clone();
            //Only assign trainee and mentor ID to activity if those params are passed in
            //Otherwise, create only the activity and not the association
            if (this.hasAssignment) {
                this.newCustomActivity.traineeId = await this.getTraineeId();
                this.newCustomActivity.mentorProfileId = this.trainee.mentorId;
            }
        }

        async save() {
            //Double-check
            const createCheck = await this.$bvModal.msgBoxConfirm(sprintf(
                'Are you sure you want to create custom activity %s?',
                this.newCustomActivity.title), {
                title: 'Confirm Creation',
                noCloseOnBackdrop: true,
                noCloseOnEsc: true,
                headerBgVariant: 'dark',
                headerTextVariant: 'white'
            });
            if (!createCheck) {
                return;
            }
            //if date is not null, set day of selected month/year to last day of the month
            if (!!this.newCustomActivity.scheduled) {
                this.newCustomActivity.scheduled = set(
                    endOfMonth(this.newCustomActivity.scheduled),
                    { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
            }
            //Save activity (BE will also save new assignment as applicable)
            try {
                await store.dispatch('activities/processCustomActivity', this.newCustomActivity);
                this.$emit('done');
            }
            catch (error) {
                await this.$bvModal.msgBoxOk(error.message, errorModalOptions);
            }
        }

        errorState(field) {
            //errors[field] returns true when an error is present
            //errorState(field) returns false when an error is present for field control
            return !this.newCustomActivity.errors[field];
        }

        get disableSave() {
            //Return "some" true for function to return true and disable submission
            const errors = this.newCustomActivity.errors;
            return _.some(Object.keys(errors), (f) => errors[f]);
        }

        get customActivityTypes() {
            return [CustomActivityType.MA, CustomActivityType.OJT];
        }
    }
</script>

<style>

</style>